export default __webpack_public_path__ + "static/media/c4.d934b089.png";